export namespace GamingAggregatorId {
  export const Starsoft = 1n;
  export const Softswiss = 2n;
  export const PGSoft = 3n;
  export const Spribe = 4n;
  export const PragmaticPlay = 5n;
  export const Evolution = 6n;
  export const Playtech = 7n;
  export const Betby = 8n;
  export const First = 9n;
}

export type GamingAggregatorIdType =
  (typeof GamingAggregatorId)[keyof typeof GamingAggregatorId];
